import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { ContentType, Page } from '@tracking';

import GraphicsPageLayout from './Layout';
import type { GraphicsPageProps } from './interfaces';
import './styles.scss';

const queryClient = new QueryClient();

const GraphicsPage = ({
  env,
  data,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  relatedArticles,
  relatedGraphics,
}: GraphicsPageProps) => {
  const { Track } = useEventTracking({
    contentId: data?.id,
    contentType: ContentType.Graphics,
    page: Page.Graphic,
    pageId: data?.id,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <GraphicsPageLayout
            {...data}
            relatedArticles={relatedArticles}
            relatedGraphics={relatedGraphics}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default GraphicsPage;
